import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Configuration, LayerGroupIcon, Location, Payment, PercentageIcon, StickyNoteIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/configuration-management')({
  loader: ({ context }) => {
    context.groupLabel = 'configurationManagement.sidebar.title';
    context.childRoutes = [
      {
        id: 'configurationManagement.sidebar.menu.location',
        label: 'Location',
        path: '/configuration-management/location',
        icon: Location,
      },
      {
        id: 'configurationManagement.sidebar.menu.hoslogPlans',
        label: 'Hoslog Plans',
        path: '/configuration-management/hoslog-plans',
        icon: StickyNoteIcon,
      },
      {
        id: 'configurationManagement.sidebar.menu.commissions',
        label: 'Commissions',
        path: '/configuration-management/commissions',
        icon: PercentageIcon,
      },
      {
        id: 'configurationManagement.sidebar.menu.charges',
        label: 'Charges',
        path: '/configuration-management/charges',
        icon: PercentageIcon,
      },
      {
        id: 'configurationManagement.sidebar.menu.withdrawalSetup',
        label: 'Withdrawals Setup',
        path: '/configuration-management/withdrawals-setup',
        icon: Payment,
      },
      {
        id: 'configurationManagement.sidebar.menu.groupsManagement',
        label: 'Conversion Activity',
        path: '/configuration-management/group-management',
        icon: LayerGroupIcon,
      },
      {
        id: 'configurationManagement.sidebar.menu.discountManagement',
        label: 'Discount Management',
        path: '/configuration-management/discount-management',
        icon: PercentageIcon,
      },
    ];
    return {
      crumb: (
        <CrumbTitle
          title="Configuration Management"
          id="configurationManagement.crumb.configuration"
          icon={Configuration}
        />
      ),
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
